import { getApiBaseUrlTenant } from "./getApiBaseUrl";

/**
 * @description
 * This Domain is used for all the api calls
 * @type {string} Domain
 */
export const Domain = `${process.env.REACT_APP_MICRO_API_URL}/api/tenant`;

/**
 * @description
 * This Domain is used for the tenant api calls like (teacher apis, schoole admin apis)
 * @type {string} TENANT_DOMAIN
 * */
export const TENANT_DOMAIN = getApiBaseUrlTenant();
